var system = {};
module['exports'] = system;
system.directoryPaths = require("./directoryPaths");
system.mimeTypes = require("./mimeTypes");
